import { connector } from '../../../../variables/services';
import { getUser } from '../../../../scripts/auth';
import { authFecth } from '../../../../scripts/requests';
// import { deleteConnector, getConnector } from '../utils';


class Connector {
    constructor(name, id, mode, exitWindow, connector_type) {
        this.exitWindow = exitWindow;
        this.name = name;
        this.id = id;
        this.connector_type = connector_type;
        this.submitClass = mode === "create" ? "connect": "edit";
        this.cancelClass = mode === "create" ? "cancel": "delete";
        this.method = mode === "create" ? "POST" : "PUT";
        this.mode = mode;
        // this.data = data;
        // this.setData = setData;
      }
  
    titleCase = (str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    handleSubmit = async (data) => {
        const user = await getUser()
        let body = {
            name: this.name,
            connector_type: this.connector_type,
            account_id: user.account_id,
            [this.connector_type]: data
        }
        const scope = getScope();
        body = {...body, ...scope};
        if (this.method === "PUT") {
            body.id = this.id
        }
            authFecth(connector + "/connection", this.method, undefined, body)
            .then(res => {
            if (!res.ok) { 
                return res.json().then(data => {
                    alert("Failed to create connection: " + data.message)
                    throw new Error("Error: " + (data.message || "Unknown error")); // Handle API error messages
                });
            }
            return res.json(); // Only parse JSON if response is OK (200)
            })
            .then(data => {
                this.exitWindow()
            })
            .catch(error => {
            // setError(error.message); // Store error message in state
                console.error(`Failed to ${this.mode} connection:`, error);
                this.exitWindow()
            });

        }

    handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        this.setData({
            ...this.data,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    handleFileChange = (e) => {
        this.setData({
            ...this.data,
            [e.target.name]: e.target.files[0].name
        });
    };

    handleCancel = async() => {
        // if (this.cancelClass === "delete") {
        //     await this.deleteConnector(this.id);
        // }
        this.exitWindow()
    }
    getConnector = (id) => {
        return authFecth(`${connector}/connection`, "GET", {id: id})
        .then(res => {
            if (!res.ok) { 
                return res.json().then(data => {
                    throw new Error("Error: " + (data.message || "Unknown error")); // Handle API error messages
                });
            }
            return res.json();
        })
        .catch(error => {
            console.error("Error fetching connection:", error);
            throw error; // Rethrow so callers can handle it
        });
    };
    
    deleteConnector = (id) => {
        return authFecth(`${connector}/connection`, "DELETE", {id: id})
        .then(res => {
            if (!res.ok) { 
                return res.json().then(data => {
                    throw new Error("Error: " + (data.message || "Unknown error")); // Handle API error messages
                });
            }
        })
        .catch(error => {
            console.error("Error fetching connection:", error);
            throw error; // Rethrow so callers can handle it
        });
    };

    loadData = async (data) => {
        if (this.mode === "edit") {
            const conn = await this.getConnector(this.id);
            Object.keys(data).forEach(key => {
                if (conn[key] !== undefined) {
                    data[key] = conn[key];
                    
                }
            })
            // this.setData(data)
            return data;
        }
    }
    
  }

function getScope() {
    let res = {scope: "yellow"}
    const path = window.location.pathname.split('/');
    if (path.length >= 3 && path[1] == "project"){
        res = {
            scope: "project",
            project_id: path[2]
        }
    }
    else {
        res = {
            scope: "account"
        }
    }
    return res;
}

export const rename = (id, name) => {
    let body = {
        "name": name
    }
            authFecth(`${connector}/connection`, "PUT", {id: id}, body)
            .then(res => {
            if (!res.ok) { 
                return res.json().then(data => {
                throw new Error("Error: " + (data.message || "Unknown error")); // Handle API error messages
                });
            }
            return res.json(); // Only parse JSON if response is OK (200)
            })
            .then(data => {
            })
            .catch(error => {
            // setError(error.message); // Store error message in state
            console.error("Error fetching conncetion:", error);
            });
        
}


export default Connector;

  

  